(function () {
  'use strict';

  var HERO_SELECTOR = '#Hero-raev-hero';
  var MOBILE_QUERY = '(max-width: 749px)';
  var mobileMedia = window.matchMedia(MOBILE_QUERY);
  var scriptElement = document.currentScript;
  var mobileLogoUrl = '';

  try {
    if (scriptElement && scriptElement.src) {
      mobileLogoUrl = new URL('raev-logo-mobile.png', scriptElement.src).href;
    }
  } catch (error) {
    mobileLogoUrl = '';
  }

  function setStaticStyles(element, properties) {
    if (!element) return;

    Object.keys(properties).forEach(function (property) {
      element.style.setProperty(property, properties[property], 'important');
    });
  }

  function rememberOriginalSource(image) {
    if (!image || image.dataset.raevOriginalLogoCaptured === 'true') return;

    image.dataset.raevOriginalLogoCaptured = 'true';
    image.dataset.raevOriginalLogoSrc = image.getAttribute('src') || '';
    image.dataset.raevOriginalLogoSrcset = image.getAttribute('srcset') || '';
    image.dataset.raevOriginalLogoSizes = image.getAttribute('sizes') || '';
    image.dataset.raevOriginalLogoHadSrcset = image.hasAttribute('srcset') ? 'true' : 'false';
    image.dataset.raevOriginalLogoHadSizes = image.hasAttribute('sizes') ? 'true' : 'false';
  }

  function useCroppedMobileSource(image) {
    if (!image || !mobileLogoUrl) return;

    rememberOriginalSource(image);
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');

    if (image.src !== mobileLogoUrl) {
      image.src = mobileLogoUrl;
    }
  }

  function restoreOriginalSource(image) {
    if (!image || image.dataset.raevOriginalLogoCaptured !== 'true') return;

    var originalSrc = image.dataset.raevOriginalLogoSrc || '';
    var originalSrcset = image.dataset.raevOriginalLogoSrcset || '';
    var originalSizes = image.dataset.raevOriginalLogoSizes || '';

    if (originalSrc) image.setAttribute('src', originalSrc);

    if (image.dataset.raevOriginalLogoHadSrcset === 'true') {
      image.setAttribute('srcset', originalSrcset);
    } else {
      image.removeAttribute('srcset');
    }

    if (image.dataset.raevOriginalLogoHadSizes === 'true') {
      image.setAttribute('sizes', originalSizes);
    } else {
      image.removeAttribute('sizes');
    }
  }

  function clearStaticStyles(element, properties) {
    if (!element) return;
    properties.forEach(function (property) {
      element.style.removeProperty(property);
    });
  }

  function getHeroElements() {
    var hero = document.querySelector(HERO_SELECTOR);
    var content = hero && hero.querySelector('.hero__content-wrapper');
    var block = content && content.querySelector('.logo-block');
    var wrapper = block && block.querySelector('.logo-block__image-wrapper');
    var image = wrapper && wrapper.querySelector('.logo-block__image');

    return {
      hero: hero,
      content: content,
      block: block,
      wrapper: wrapper,
      image: image
    };
  }

  function restoreDesktopLogo(elements) {
    if (!elements.image) return;

    restoreOriginalSource(elements.image);

    clearStaticStyles(elements.content, [
      'opacity', 'transform', 'translate', 'scale', 'rotate',
      'transition', 'animation', 'will-change'
    ]);
    clearStaticStyles(elements.block, [
      'width', 'max-width', 'opacity', 'transform', 'translate', 'scale',
      'rotate', 'transition', 'animation', 'will-change'
    ]);
    clearStaticStyles(elements.wrapper, [
      'opacity', 'transform', 'translate', 'scale', 'rotate',
      'transition', 'animation', 'will-change'
    ]);
    clearStaticStyles(elements.image, [
      'width', 'max-width', 'height', 'opacity', 'transform', 'translate',
      'scale', 'rotate', 'transition', 'animation', 'will-change'
    ]);
  }

  function lockMobileHeroLogo() {
    var elements = getHeroElements();

    if (!elements.hero || !elements.content || !elements.block || !elements.wrapper || !elements.image) return;

    if (!mobileMedia.matches) {
      restoreDesktopLogo(elements);
      return;
    }

    /* Guard read by initHeroLogoScroll() in raev-horizon.js. */
    elements.image.dataset.raevHeroLogoReady = 'true';
    elements.image.dataset.raevMobileStaticLogo = 'true';

    useCroppedMobileSource(elements.image);

    setStaticStyles(elements.content, {
      opacity: '1',
      transform: 'none',
      translate: 'none',
      scale: 'none',
      rotate: 'none',
      transition: 'none',
      animation: 'none',
      'will-change': 'auto'
    });

    setStaticStyles(elements.block, {
      width: 'min(44vw, 10.75rem)',
      'max-width': 'min(44vw, 10.75rem)',
      opacity: '1',
      transform: 'none',
      translate: 'none',
      scale: 'none',
      rotate: 'none',
      transition: 'none',
      animation: 'none',
      'will-change': 'auto'
    });

    setStaticStyles(elements.wrapper, {
      opacity: '1',
      transform: 'none',
      translate: 'none',
      scale: 'none',
      rotate: 'none',
      transition: 'none',
      animation: 'none',
      'will-change': 'auto'
    });

    setStaticStyles(elements.image, {
      width: '100%',
      'max-width': '100%',
      height: 'auto',
      opacity: '1',
      transform: 'none',
      translate: 'none',
      scale: 'none',
      rotate: 'none',
      transition: 'none',
      animation: 'none',
      'will-change': 'auto'
    });
  }

  /* Loaded before raev-horizon.js, so the mobile scroll effect is guarded. */
  lockMobileHeroLogo();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lockMobileHeroLogo, { once: true });
  }

  window.addEventListener('pageshow', lockMobileHeroLogo);
  document.addEventListener('shopify:section:load', lockMobileHeroLogo);

  if (typeof mobileMedia.addEventListener === 'function') {
    mobileMedia.addEventListener('change', lockMobileHeroLogo);
  } else if (typeof mobileMedia.addListener === 'function') {
    mobileMedia.addListener(lockMobileHeroLogo);
  }
})();
